module.exports = __webpack_public_path__ + "static/media/icon-done-off.95f4f163.svg";